import { Box, Typography } from '@mui/material';
import { MdOutlineLocalPhone, MdOutlineSms, MdCheck, MdClose, MdOutlineMailOutline } from 'react-icons/md';
import A2PBadgeIcon from '@/assets/icons/A2PBadgeIcon';
import SipIcon from '@/assets/icons/SipIcon';
import { BADGE_STYLES, CapabilityBadge } from '../capabilityBadges';

type Props = {
  badge: CapabilityBadge;
};

function BadgeIcon({ badge }: { badge: CapabilityBadge }) {
  const color = BADGE_STYLES[badge].color;

  switch (badge) {
    case 'a2p':
      return <A2PBadgeIcon />;
    case 'voice':
      return <MdOutlineLocalPhone size={12} color={color} />;
    case 'sms':
      return <MdOutlineSms size={12} color={color} />;
    case 'sip':
      return <SipIcon width={12} height={12} color={color} />;
    case 'sip_registered':
      return <MdCheck size={12} color={color} />;
    case 'sip_failed':
      return <MdClose size={12} color={color} />;
    case 'hosted_sms':
      return <MdOutlineMailOutline size={12} color={color} />;
    default:
      return null;
  }
}

export default function CapabilityBadgeChip({ badge }: Props) {
  const style = BADGE_STYLES[badge];

  return (
    <Box
      component='span'
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        height: 22,
        px: '8px',
        borderRadius: '999px',
        bgcolor: style.bg,
        color: style.color,
        whiteSpace: 'nowrap',
        lineHeight: 1
      }}
    >
      <Box component='span' sx={{ display: 'inline-flex', alignItems: 'center', flexShrink: 0 }}>
        <BadgeIcon badge={badge} />
      </Box>
      <Typography
        component='span'
        sx={{
          fontSize: 11,
          fontWeight: 600,
          lineHeight: 1,
          letterSpacing: '0.01em',
          color: style.color
        }}
      >
        {style.label}
      </Typography>
    </Box>
  );
}
